import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CarouselThumbnailDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    concentric
} from "../../../../helpers/theme/concentric";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    ring: {
        ...StyleSheet.absoluteFill,
        borderStyle: "solid"
    },
    gap: {
        ...StyleSheet.absoluteFill,
        borderStyle: "solid"
    },
    layer: {
        ...StyleSheet.absoluteFill,
        pointerEvents: "none"
    },
    container: {
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    media: {
        pointerEvents: "none",
        overflow: "hidden",
        aspectRatio: 1,
        width: "100%"
    }
});

export const useStyles = ({
    controlHeights,
    isFocusVisible,
    shapeConfigs,
    radiuses,
    borders,
    spaces,
    colors
}: CarouselThumbnailDynamicStyleType) => {
    const thumbSize = controlHeights.large + spaces.spacingMd;

    const styles = {
        media: {
            backgroundColor: colors.content.container.subtle,
            ...getCornerStyle({
                radius: radiuses.form,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        gap: {
            borderColor: colors.content.container.raised,
            ...getCornerStyle({
                radius: concentric({
                    inset: borders.focus,
                    outer: radiuses.form,
                    role: radiuses.form
                }),
                shapeConfigs
            }),
            borderWidth: borders.focus
        } as Mutable<ViewStyle>,
        ring: {
            borderColor: colors.content.text.high,
            ...getCornerStyle({
                radius: radiuses.form,
                shapeConfigs
            }),
            borderWidth: borders.focus
        } as Mutable<ViewStyle>,
        container: {
            ...getCornerStyle({
                radius: radiuses.form,
                shapeConfigs
            }),
            width: thumbSize
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.container, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
